import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { GET } from "../utils/apicalls";
import { Form, Card, Row, Col, Typography, Collapse, Divider } from "antd";
import { API } from "../config/api";
import "./client.css"; // New custom CSS for the updated profile design

const { Title, Text } = Typography;
const { Panel } = Collapse;

function Client() {
  const user: any = useSelector((state: RootState) => state?.user); // Access user state
  const [ClientData, setClientData] = useState<any>();
  const [form] = Form.useForm();

  useEffect(() => {
    getClientData();
  }, []);

  const getClientData = async () => {
    try {
      let api = API.CLIENT_GET_ONE + user.id;
      const Data: any = await GET(api, {});
      setClientData(Data?.data);
      form.setFieldsValue(Data?.data);
    } catch (error) {
      console.log("Error fetching client data:", error);
    }
  };

  return (
    <>
      <div style={{ paddingTop: "20px", textAlign: "center" }}>
        <Title level={3}>Client Information</Title>
      </div>

      <Row justify="center" gutter={[16, 16]}>
        {/* Card 1 */}
        <Col xs={24} sm={22} md={20} lg={16} xl={12}>
          <Card>
            <Title level={3}>{ClientData?.name}'s Profile</Title>
            {/* Profile Details */}
            <section className="profile-details">
              <Text strong>Email: </Text>
              <Text>{ClientData?.client_email}</Text>
              <Divider />
              <Text strong>Phone: </Text>
              <Text>{ClientData?.client_phone}</Text>
              <Divider />
              <Text strong>Username: </Text>
              <Text>{ClientData?.username}</Text>
            </section>
          </Card>
        </Col>

        {/* Card 2 */}
        <Col xs={24} sm={22} md={20} lg={16} xl={12}>
          <Card>
            {/* Accordion Style for Expandable Sections */}
            <Collapse accordion>
              {/* Personal Information */}
              <Panel header="Personal Information" key="1">
                <Row gutter={16}>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Company Name: </Text>
                      <Text>{ClientData?.companyName}</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Pin Code: </Text>
                      <Text>{ClientData?.pincode}</Text>
                    </div>
                  </Col>
                </Row>
              </Panel>

              {/* Project Information */}
              {/* <Panel header="Project Information" key="2">
                <Row gutter={16}>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Project Name: </Text>
                      <Text>{ClientData?.project_name || "N/A"}</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Start Date: </Text>
                      <Text>
                        {new Date(ClientData?.start_date).toLocaleDateString()}
                      </Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>End Date: </Text>
                      <Text>
                        {new Date(ClientData?.end_date).toLocaleDateString()}
                      </Text>
                    </div>
                  </Col>
                </Row>
              </Panel> */}

              {/* Account Information */}
              <Panel header="Account Information" key="3">
                <Row gutter={16}>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Domain Username: </Text>
                      <Text>{ClientData?.domain_username}</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Domain Password: </Text>
                      <Text>{ClientData?.domain_password}</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Email Password: </Text>
                      <Text>{ClientData?.email_password}</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Facebook Username: </Text>
                      <Text>{ClientData?.fb_username}</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Facebook Password: </Text>
                      <Text>{ClientData?.fb_password}</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Instagram Username: </Text>
                      <Text>{ClientData?.insta_username}</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Instagram Password: </Text>
                      <Text>{ClientData?.insta_password}</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Hostinger Username: </Text>
                      <Text>{ClientData?.hostinger_username}</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="info-item">
                      <Text strong>Hostinger Password: </Text>
                      <Text>{ClientData?.hostinger_password || "N/A"}</Text>
                    </div>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default Client;
